interface Pointer { pointerId: number; clientX: number; clientY: number }
const distance = (a: Pointer, b: Pointer) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY)

/** A swipe, hold or interrupted touch breaks the pair; a single tap has no action. */
export function createDoubleTap(now = () => performance.now()) {
  let down: { point: Pointer; time: number } | null = null
  let previous: { point: Pointer; time: number } | null = null
  const cancel = () => { down = null; previous = null }
  return {
    start(point: Pointer, primary: boolean, button: number) {
      if (!primary || button !== 0 || down) { cancel(); return }
      down = { point, time: now() }
    },
    move(point: Pointer) {
      if (down?.point.pointerId === point.pointerId && distance(down.point, point) > 8) cancel()
    },
    end(point: Pointer) {
      if (!down || down.point.pointerId !== point.pointerId) return false
      const time = now()
      if (time - down.time > 250 || distance(down.point, point) > 8) { cancel(); return false }
      down = null
      if (previous && time - previous.time <= 320 && distance(previous.point, point) <= 32) {
        previous = null
        return true
      }
      previous = { point, time }
      return false
    },
    cancel,
  }
}
